import './DetailsPurchases.scss';
import { Card, Icon, Button } from '@design-system/index';
import { MutationTable } from '@components/Table/MutationTable/MutationTable';
import { ColumnDef } from '@tanstack/react-table';
import { formatDate } from '@utils/dates';
import { OrderStatus, OrderTable } from '@services/product/order/order.types';
import { ORDER_STATUS } from '@utils/enumTranslation';
import { useGetMemberOrdersMutation } from '@services/product/order/order.endpoints';
import { OrderStatusBadge } from '@components/OrderStatusBadge/OrderStatusBadge';
import { formatMoney } from '@utils/numbers';
import { useDetailsPurchasesVM } from './useDetailsPurchasesVM';
import { Pdf } from '@assets/images/icons';

export default function DetailsPurchases() {
    const {
        navigate,
        id,
        columnHelper
    } = useDetailsPurchasesVM();

    const columns = [
        columnHelper.accessor('woocommerceId', {
            header: 'Référence',
            enableSorting: true,
            minSize: 160,
            meta: {
                clickable: true
            },
            cell: (info) => <>{'#' + info.getValue()}</>
        }),
        columnHelper.accessor('createdAt', {
            header: 'Date de la commande',
            enableSorting: true,
            minSize: 160,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatDate(info.getValue() as string)}</>
        }),
        columnHelper.accessor('status', {
            header: 'Statut',
            enableSorting: true,
            minSize: 160,
            meta: {
                clickable: true
            },
            cell: (info) => <OrderStatusBadge status={info.getValue() as OrderStatus} />
        }),
        columnHelper.accessor('total', {
            header: 'Total TTC',
            enableSorting: true,
            minSize: 160,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatMoney(info.getValue() as number)}</>
        }),
        columnHelper.display({
            id: 'action',
            size: 0,
            header: 'E-billets',
            meta: {
                style: {
                    textAlign: 'center'
                }
            },
            cell: (info) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                        {info.row.original.etickets.map((eticket) => (
                            <Button
                                variant="icon"
                                color="primary"
                                size="small"
                                icon={<Icon icon={<Pdf />} size={20} color="primary" />}
                                hoverIcon={<Icon icon={<Pdf />} size={20} color="secondary" />}
                                onClick={() => {
                                    window.open(eticket.pdfLink, '_blank');
                                }}
                            />
                        ))}
                    </div>
                );
            }
        })

    ] as ColumnDef<OrderTable>[];

    return (
        <div className="details-member-container">
            <Card headerType="very-light" headerTitle="Liste des commandes">
                <MutationTable
                    key={'orders'}
                    columns={columns}
                    className="no-card"
                    mutationHook={useGetMemberOrdersMutation}
                    mutationHookParams={{ id: id }}
                    onRowClick={(row) => navigate(`/products-management/orders/${row.id}/details`)}
                    defaultSorting={{
                        field: 'woocommerceId',
                        direction: 'desc'
                    }}
                    selectable={false}
                    noHeader
                    filters={[
                        {
                            id: "createdAt",
                            label: "Date de la commande",
                            type: "date",
                            comparatorTypes: ['isBetween', 'isBefore', 'isAfter', 'equals']
                        },
                        {
                            id: "status",
                            label: "Statut",
                            type: "select",
                            options: Object.entries(ORDER_STATUS).map(([state, label]) => ({label, value: state as OrderStatus}))
                        },
                    ]}
                />
            </Card>
        </div>
    );
}
